import BrandSubscriptionDetails from './BrandSubscriptionDetails';
import { BrandSubscriptionModel } from 'owa-brands-subscription';
import { observer } from 'mobx-react';
import { PersonaSize } from 'office-ui-fabric-react/lib/Persona';
import PersonaControl from 'owa-persona/lib/components/PersonaControl';
import * as React from 'react';
import {
    personaCardBehavior,
    PersonaCardBehaviorProps,
} from 'owa-persona/lib/components/PersonaCardBehavior';
const styles = require('./BrandSubscriptionView.scss');

export interface BrandSubscriptionViewProps {
    brandSubscriptions: BrandSubscriptionModel[];
    isUnsubscribed: boolean;
}

@observer
export default class BrandSubscriptionView extends React.Component<BrandSubscriptionViewProps, {}> {
    render() {
        const subscription = this.props.brandSubscriptions[0];
        // If the brand subscription has only 1 grouped entry and the brand name matches the subscription display name
        // then render as a Regular subscription
        if (
            subscription.type === 'BrandSubscription' &&
            (this.props.brandSubscriptions.length > 1 ||
                (this.props.brandSubscriptions.length === 1 &&
                    subscription.brand.brandName.toLocaleLowerCase() !==
                        subscription.smtpInfo.displayName.toLocaleLowerCase()))
        ) {
            return this.rendeGroupedSubscription(subscription);
        }

        return this.renderRegularSubscription(subscription);
    }

    private rendeGroupedSubscription = (subscription: BrandSubscriptionModel): JSX.Element => {
        if (subscription.type !== 'BrandSubscription') {
            return null;
        }
        return (
            <div className={styles.brandView}>
                <div className={styles.row1}>
                    <div className={styles.personaPhoto}>
                        <BrandsPersonaCardWrapper
                            name={subscription.smtpInfo.displayName}
                            emailAddress={subscription.smtpInfo.smtpAddress}
                        />
                    </div>
                    <div className={styles.brandName}> {subscription.brand.brandName} </div>
                </div>
                <div className={styles.detailsMultiLine}>{this.getBrandSubscriptionDetails()}</div>
            </div>
        );
    };

    private renderRegularSubscription = (subscription: BrandSubscriptionModel): JSX.Element => {
        return (
            <div className={styles.brandView}>
                <div className={styles.row1}>
                    <div className={styles.personaPhoto}>
                        <BrandsPersonaCardWrapper
                            name={subscription.smtpInfo.displayName}
                            emailAddress={subscription.smtpInfo.smtpAddress}
                        />
                    </div>
                    <div className={styles.detailsSingleLine}>
                        <BrandSubscriptionDetails
                            displayName={subscription.smtpInfo.displayName}
                            smtp={subscription.smtpInfo.smtpAddress}
                            smtpIdentifier={subscription.smtpInfo.smtpIdentifier}
                            unsubscribeHttpUri={subscription.unsubscribeHttpUris[0]}
                            unsubscribeSilentUris={subscription.unsubscribeSilentUris}
                            key={subscription.smtpInfo.smtpAddress}
                            isUnsubscribed={this.props.isUnsubscribed}
                        />
                    </div>
                </div>
            </div>
        );
    };

    private getBrandSubscriptionDetails = (): JSX.Element[] => {
        const detailsView: JSX.Element[] = this.props.brandSubscriptions.map(subscription => {
            return (
                <BrandSubscriptionDetails
                    displayName={subscription.smtpInfo.displayName}
                    smtp={subscription.smtpInfo.smtpAddress}
                    smtpIdentifier={subscription.smtpInfo.smtpIdentifier}
                    unsubscribeHttpUri={subscription.unsubscribeHttpUris[0]}
                    unsubscribeSilentUris={subscription.unsubscribeSilentUris}
                    key={subscription.smtpInfo.smtpAddress}
                    isUnsubscribed={this.props.isUnsubscribed}
                />
            );
        });

        return detailsView;
    };
}

@personaCardBehavior
class BrandsPersonaCardWrapper extends React.Component<PersonaCardBehaviorProps, any> {
    render(): any {
        const { name, emailAddress } = this.props;

        return (
            <PersonaControl
                name={name}
                emailAddress={emailAddress}
                size={PersonaSize.size28}
                showPersonaDetails={false}
            />
        );
    }
}
